import produce from "immer"
import { OkrObjective } from "server/models"

import { ASC } from "const"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initOkrObjective: OkrObjective = {
    id: null,
    sessionId: null,
    objectiveId: null,
    keyResultId: null,
    title: "",
    description: "",
}

const initOkrObjectiveState: types.OkrObjectiveState = {
    baseRoute: null,
    objectiveRoute: null,

    objectiveList: {},
    objectiveIds: [],
    objectiveEdit: initOkrObjective,

    // to select parent
    availableSessions: [],
    availableObjectives: {},
    availableKeyResults: {},

    sortColumn: "title",
    sortOrder: ASC,
    filters: {
        search: null,
    },

    // popup menu
    active: null,
    menuShow: false,
    menuTarget: null,
    showConfirmDelete: false,

    reloadList: true,
    reloadEdit: true,
}

const okrObjectiveReducer = produce((
    draft: types.OkrObjectiveState = initOkrObjectiveState,
    action: ActionTypes = null,
): types.OkrObjectiveState => {
    switch (action.type) {
        case types.OKR_OBJECTIVE_BASE_ROUTE:
            draft.baseRoute = action.baseRoute
            return draft

        case types.OKR_OBJECTIVE_ROUTE:
            draft.objectiveRoute = action.objectiveRoute
            return draft

        case types.OKR_OBJECTIVE_LIST:
            draft.objectiveList = action.objectiveList
            return draft

        case types.OKR_OBJECTIVE_IDS:
            draft.objectiveIds = action.objectiveIds
            return draft

        case types.OKR_OBJECTIVE_EDIT:
            draft.objectiveEdit = action.objective
            return draft


        // to select parent
        case types.OKR_OBJECTIVE_AVAILABLE_SESSIONS:
            draft.availableSessions = action.sessions
            return draft

        case types.OKR_OBJECTIVE_AVAILABLE_OBJECTIVES:
            draft.availableObjectives = action.objectives
            return draft

        case types.OKR_OBJECTIVE_AVAILABLE_KEY_RESULTS:
            draft.availableKeyResults = action.keyResults
            return draft


        case types.OKR_OBJECTIVE_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.OKR_OBJECTIVE_FILTERS:
            draft.filters = action.filters
            return draft


        // popup menu
        case types.OKR_OBJECTIVE_ACTIVE:
            draft.active = action.active
            return draft

        case types.OKR_OBJECTIVE_POPUP_MENU_SHOW:
            draft.menuShow = action.show
            return draft

        case types.OKR_OBJECTIVE_POPUP_MENU_TARGET:
            draft.menuTarget = action.target
            return draft

        case types.OKR_OBJECTIVE_SHOW_CONFIRM_DELETE:
            draft.showConfirmDelete = action.show
            return draft


        case types.OKR_OBJECTIVE_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.OKR_OBJECTIVE_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default okrObjectiveReducer
